import { defineComponent } from '@vue/composition-api';
import __vue_component__ from '../SdsBaseInput/SdsBaseInput.vue.js';

var script = defineComponent({
    name: 'SdsInputText',
    props: {
        name: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: false,
            default: undefined,
        },
        label: {
            type: String,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        isReadOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        isClearable: {
            type: Boolean,
            required: false,
            default: false,
        },
        autocomplete: {
            type: String,
            required: false,
            default: undefined,
        },
        message: {
            type: String,
            required: false,
            default: undefined,
        },
        status: {
            type: String,
            required: false,
            default: undefined,
        },
        dataTestId: {
            type: String,
            required: false,
            default: undefined,
        },
        maxlength: {
            type: Number,
            required: false,
            default: undefined,
        },
    },
    emits: [
        'update:value',
        'focus',
        'blur',
        'click',
        'keydown',
        'keypress',
        'keyup',
        'beforeinput',
        // Exposed if we need analytics or some reaction to this
        'cleared',
    ],
    components: {
        SdsBaseInput: __vue_component__,
    },
});

export default script;
